var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "#FCF2BB",
    stroke: "#EEA111",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.4447L20.4447 8L22 9.55531L16.5553 15L22 20.4447L20.4447 22L15 16.5553L9.55531 22L8 20.4447L13.4447 15L8 9.55531L9.55531 8L15 13.4447Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagDelete);
export default __webpack_public_path__ + "static/media/tag_delete.ac2289bcc6eacaa21843d3f9bc883bc7.svg";
export { ForwardRef as ReactComponent };